export default __webpack_public_path__ + "static/media/rou_walk.30b498fd.gif";